import api from "../../../utils/api";
import { setAlert } from "../alert";
import { handleError } from "../errors";
import { DELETE_WORKER_TIMESHEET_HOURS, DELETE_WORKER_TIMESHEET_HOURS_ERROR, GENERATE_WORKER_TIMESHEET_HOURS, GENERATE_WORKER_TIMESHEET_HOURS_ERROR, GET_WORKER_PROJECT_LIST, GET_WORKER_PROJECT_LIST_ERROR, GET_WORKER_TIMESHEET_BULK_LIST, GET_WORKER_TIMESHEET_BULK_LIST_ERROR, GET_WORKER_TIMESHEET_HOURS, GET_WORKER_TIMESHEET_HOURS_ERROR, GET_WORKER_TIMESHEET_ID, GET_WORKER_TIMESHEET_ID_ERROR, GET_WORKER_TIMESHEET_LIST, GET_WORKER_TIMESHEET_LIST_ERROR, GET_WORKER_TIMESHEET_STATUS_LIST, GET_WORKER_TIMESHEET_STATUS_LIST_ERROR, GET_WORKER_TIMESHEET_WORKER_RATES, GET_WORKER_TIMESHEET_WORKER_RATES_ERROR, RESET_WORKER_TIMESHEET_DETAILS, RESET_WORKER_TIMESHEET_HOUR_DETAILS, SAVE_WORKER_TIMESHEET, SAVE_WORKER_TIMESHEET_ERROR, SAVE_WORKER_TIMESHEET_HOURS, SAVE_WORKER_TIMESHEET_HOURS_ERROR, WORKER_BULK_ACTION_TIMESHEET, WORKER_BULK_ACTION_TIMESHEET_ERROR } from "../types";

export const get_worker_timesheet_status_list = () => async (dispatch) => {
    try {
        const res = await api.get(`api/wor-timesheet/get-timesheet-status-list`);
        dispatch({
            type: GET_WORKER_TIMESHEET_STATUS_LIST,
            payload: res.data,
        });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_WORKER_TIMESHEET_STATUS_LIST_ERROR,
        });
    }
};

export const get_worker_timesheet_list = (refNum, status, startDate, endDate, projectName) => async (dispatch) => {
    try {
        const res = await api.get(`api/wor-timesheet/get-timesheet-list`,
            {
                params: {
                    refNum: refNum,
                    status: status,
                    fromDate: startDate,
                    toDate: endDate,
                    projectName: projectName,
                }
            }
        );
        dispatch({
            type: GET_WORKER_TIMESHEET_LIST,
            payload: res.data,
        });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_WORKER_TIMESHEET_LIST_ERROR,
        });
    }
};

export const get_worker_bulk_action_list = () => async (dispatch) => {
    try {
        const res = await api.get(`api/wor-timesheet/get-bulk-action-list`);
        dispatch({
            type: GET_WORKER_TIMESHEET_BULK_LIST,
            payload: res.data,
        });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_WORKER_TIMESHEET_BULK_LIST_ERROR,
        });
    }
};

export const worker_bulk_action_timesheet = (bulkData) => async (dispatch) => {
    try {
        const res = await api.post(`api/wor-timesheet/bulk-update-timesheet-status`, bulkData)
        dispatch({
            type: WORKER_BULK_ACTION_TIMESHEET,
            payload: true
        })
        dispatch(setAlert(res.data.message, 'success'))
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: WORKER_BULK_ACTION_TIMESHEET_ERROR
        })
        return false;
    }
}

export const delete_worker_timesheet = (refNumList) => async (dispatch) => {
    try {
        const res = await api.post(`api/wor-timesheet/bulk-delete-timesheet`, refNumList);
        dispatch(setAlert(res.data.message, "success"))
        return true;
    } catch (err) {
        handleError(err, dispatch);
        return false;
    }
}

export const reset_worker_timesheet_details = () => (dispatch) => dispatch({ type : RESET_WORKER_TIMESHEET_DETAILS });

export const save_worker_timesheet = (timesheet) => async (dispatch) => {
    try {
        const res = await api.post('api/wor-timesheet/save-timesheet', timesheet);
        dispatch(setAlert(res.data.message, 'success'))
        dispatch({
            type: SAVE_WORKER_TIMESHEET,
            payload: res.data
        })
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: SAVE_WORKER_TIMESHEET_ERROR })

        return false;
    }
}

export const get_worker_timesheet_by_refnum = (timesheetRefNum) => async (dispatch) => {
    try {
        const res = await api.get(`api/wor-timesheet/get-timesheet?refNum=${timesheetRefNum}`);
        dispatch({
            type: GET_WORKER_TIMESHEET_ID,
            payload: res.data
        })

    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_WORKER_TIMESHEET_ID_ERROR,
        });
    }
}

export const generate_worker_timesheet_schedule = ( client, worker, endDate ) => async (dispatch) => {
    try {
        const res = await api.get(`api/wor-timesheet/generate-timesheet-schedule`, {
            params: {
                clientId: client,
                workerId: worker,
                payPeriodEndDate: endDate,
            }
        });
        dispatch({
            type: GENERATE_WORKER_TIMESHEET_HOURS,
            payload: res.data,
        });
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GENERATE_WORKER_TIMESHEET_HOURS_ERROR,
        });
        return false;
    }
};

export const get_worker_timesheet_worker_rates = ( id ) => async (dispatch) => {
    try {
        const res = await api.get(`api/wor-timesheet/get-timesheet-rates?workerId=${id}`);
        dispatch({
            type: GET_WORKER_TIMESHEET_WORKER_RATES,
            payload: res.data,
        });
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_WORKER_TIMESHEET_WORKER_RATES_ERROR,
        });
        return false;
    }
};

export const delete_worker_timesheet_hours = ( timesheeteRef , refNum ) => async (dispatch) => {
    try {
        const res = await api.get(`api/wor-timesheet/delete-timesheet-hours?timeSheetRefNum=${timesheeteRef}&refNum=${refNum}`);
        dispatch({
            type: DELETE_WORKER_TIMESHEET_HOURS,
            payload: res.data,
        });
        dispatch(setAlert(res.data.message, "success"));
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: DELETE_WORKER_TIMESHEET_HOURS_ERROR,
        });
        return false;
    }
};

export const get_worker_timesheet_hours = ( timesheeteRef , refNum ) => async (dispatch) => {
    try {
        const res = await api.get(`api/wor-timesheet/get-timesheet-hours?timeSheetRefNum=${timesheeteRef}&refNum=${refNum}`);
        dispatch({
            type: GET_WORKER_TIMESHEET_HOURS,
            payload: res.data,
        });
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_WORKER_TIMESHEET_HOURS_ERROR,
        });
        return false;
    }
};

export const save_worker_timesheet_hours = (timesheetHours) => async (dispatch) => {
    try {
        const res = await api.post('api/wor-timesheet/save-timesheet-hours', timesheetHours);
        dispatch(setAlert(res.data.message, 'success'))
        dispatch({
            type: SAVE_WORKER_TIMESHEET_HOURS,
            payload: res.data
        })
        return true;
    } catch (err) {
        handleError(err, dispatch);
        dispatch({ type: SAVE_WORKER_TIMESHEET_HOURS_ERROR })

        return false;
    }
}

export const reset_worker_timesheet_hour_details = () => (dispatch) => dispatch({ type : RESET_WORKER_TIMESHEET_HOUR_DETAILS });

export const get_worker_project_list = (name) => async (dispatch) => {
    try {
        const res = await api.get(`api/wor-project/project-list?clientId=${name}`);
        dispatch({
            type: GET_WORKER_PROJECT_LIST,
            payload: res.data,
        });
    } catch (err) {
        handleError(err, dispatch);
        dispatch({
            type: GET_WORKER_PROJECT_LIST_ERROR,
        });
    }
};